import { slicedToArray as _slicedToArray } from '../_virtual/_rollupPluginBabelHelpers.js';
import { useState } from 'react';
import ResizeObserver from 'resize-observer-polyfill';
import useIsomorphicEffect from './use-isomorphic-effect.esm.js';
import { getTargetElement } from '../utils/dom.esm.js';
import executeWhenChangeStop from '../utils/execute-when-change-stop.esm.js';
import { noop } from '../utils/function.esm.js';

function useSize(target, options) {
  var _ref = options !== null && options !== void 0 ? options : {},
    emitWhenChangeStop = _ref.emitWhenChangeStop;
  var _useState = useState(function () {
      var el = getTargetElement(target);
      return {
        width: (el || {}).clientWidth,
        height: (el || {}).clientHeight
      };
    }),
    _useState2 = _slicedToArray(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  useIsomorphicEffect(function () {
    var el = getTargetElement(target);
    if (!el) {
      return function () {};
    }
    var onResize = function onResize(entries) {
      var target = entries[0].target;
      var _target$getBoundingCl = target.getBoundingClientRect(),
        width = _target$getBoundingCl.width,
        height = _target$getBoundingCl.height;

      /**
       * Resize observer trigger when content size changed.
       * In most case we just care about element size,
       * let's use `boundary` instead of `contentRect` here to avoid shaking.
       */
      var fixedWidth = Math.floor(width);
      var fixedHeight = Math.floor(height);
      if (state.width !== fixedWidth || state.height !== fixedHeight) {
        var size = {
          width: fixedWidth,
          height: fixedHeight
        };
        setState(size);
      }
    };
    var _ref2 = typeof emitWhenChangeStop === 'number' ? executeWhenChangeStop(onResize, emitWhenChangeStop) : typeof emitWhenChangeStop === 'boolean' ? executeWhenChangeStop(onResize) : [onResize, noop],
      _ref3 = _slicedToArray(_ref2, 2),
      callback = _ref3[0],
      reset = _ref3[1];
    var resizeObserver = new ResizeObserver(callback);
    resizeObserver.observe(el);
    return function () {
      resizeObserver.disconnect();
      reset();
    };
  }, [target, state, emitWhenChangeStop]);
  return state;
}

export default useSize;
//# sourceMappingURL=use-size.esm.js.map
